import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TrackingDto } from '../dto/tracking.dto';

@Injectable({
  providedIn: 'root'
})
export class TrackingService {
  constructor(private http: HttpClient) {}

  addTrackingRecord(trackingDto: TrackingDto) {
    return this.http.post(`${environment.apiUrl}/tracking/`, trackingDto);
  }

  addMultipleTrackingRecords(trackingDtos: TrackingDto[]) {
    return this.http.post(`${environment.apiUrl}/tracking/multiple`, trackingDtos);
  }

  getMyTrackingPoints(maxDaysInPast: number): Observable<TrackingDto[]> {
    return this.http.get<TrackingDto[]>(`${environment.apiUrl}/tracking/getMy/${maxDaysInPast}`);
  }
}
